import { render, staticRenderFns } from "./TemplateProductSpecsModal.vue?vue&type=template&id=f2130f94&scoped=true"
import script from "./TemplateProductSpecsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProductSpecsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TemplateProductSpecsModal.vue?vue&type=style&index=0&id=f2130f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2130f94",
  null
  
)

export default component.exports